import type { ReactNode } from 'react';

export const symbol_funicular: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M79-51q-15 4-27-4.83Q40-64.65 40-80q0-10.64 6.5-18.82T63-110l181-50v-127h-94q-12.75 0-21.37-8.63Q120-304.25 120-317v-423h-10q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-800 110-800h92v-50q0-12.75 8.63-21.38Q219.25-880 232-880h495q12.75 0 21.38 8.62Q757-862.75 757-850v50h93q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-10v341q0 12.75-8.62 21.37Q822.75-369 810-369h-95v80l167-46q14-4 26 5.5t12 24.97q0 10.06-6 17.79-6 7.74-16 10.74L79-51Zm265-136 271-74v-108H510v52q0 12.75-8.62 21.37Q492.75-287 480-287H344v100ZM180-347h270v-60H180v60Zm330-82h270v-60H510v60Zm-330-38h270v-273H180v273Zm330-82h270v-191H510v191Zm-60 202v-60 60Zm60-82v-60 60Z"
		/>
	</svg>
);
